import React from 'react'
import { Badge } from 'antd'

export const Channel = ({ channel, selectedChannel, onSelectChannel, clientId, personId, receipt, name, isDm = false }) => {
    return (
        <div key={channel._id} className={`channel ${selectedChannel === channel._id ? 'selected' : ''}`}
            onClick={() => onSelectChannel(clientId ? clientId : personId, channel._id, null, isDm)}>
            <div>
                {name}
                <Badge
                    count={(receipt && receipt.unread > 0) ? receipt.unread : 0}
                    overflowCount={99}
                    style={{
                        marginLeft: '10px'
                    }}
                />
            </div>
        </div>
    )
}
